/* eslint-disable */
export const phones = {
    galaxy_ace:              /gt-s5830/,
    galaxy_s2:               /gt-i9(1|2)[0-9]{2}[a-z]?|sgh-(i|t|d)(757|727|927|989|777)[a-z]?|isw11sc|sc-02c|sch-r760|sph-d710|shw-m250(k|l|s)/i,
    galaxy_s3:               /gt-i930(0|5|8)(t|n)?|sgh-(t999|i747|i9308|n064|n035)|sch-(i939|j021|r530|i535|s960|s968)|shv-e21|scl21|sc-(06d|03e)/i,
    galaxy_s3_mini:          /gt-i8190|gt-i8200|gt-9305/,
    galaxy_s4:               /gt-i950[0-9]|sc-04e|sch-i(545|959)|sch-r970(a-z)?|sgh-i337|sgh-m919|sgh-n045|shv-(e300|e330)(a-z)?|sph-l720/i,
    galaxy_s4_mini:          /gt-i919[0-9]/,
    galaxy_s5:               /g9009d|sm-g900(6|[a-z])/i,
    galaxy_s6:               /sm-g920([a-z])/i,
    galaxy_s7:               /sm-g930f/i,
    galaxy_s8:               /sm-g950f/i,
    galaxy_s8_plus:          /sm-g955f/i,
    galaxy_note:             /gt-i922(0|8)|gt-n700(0|5)b?|sc-05d|sch-i889|sgh-i717|sgh-t879|shv-e160[a-z]/i,
    galaxy_note2:            /gt-n710[0-9]|sc-02e|sch-(i605|n719|r950)|sgh-(i317|n025|t889)|shv-e250[a-z]|sph-l900/i,
    galaxy_note3:            /sm-n900[0-9]?/,
    galaxy_note4:            /sm-n910/,
    galaxy_w:                /gt-i8150/,
    Galaxy_nexus:            /galaxy nexus/,
    htc_one:                 /htc one|htc_one/,
    htc_one_m8:              /htc one_m8|htc_one_m8/,
    htc_desire_eye:          /htc desire eye/,
    htc_desire_610:          /htc desire 610/,
    htc_desire_816:          /htc desire 816/,
    htc_desire_510:          /htc desire 510/,
    htc_desire_612:          /htc desire 512/,
    htc_evo:                 /evo/,
    htc_droid:               /adr6300/,
    nexus_4:                 /nexus 4/,
    nexus_5:                 /nexus 5/,
    lg_g2:                   /lg-d80[0-9]|lg-g2|lg-l(-01f|s980)|lg-vs980/i,
    lg_g3:                   /lg-d85[0-9]|vs985 4g|lgls990/,
    lg_optimus_2x:           /optimus 2x/,
    lg_optimus_3d:           /p920/,
    lg_optimus_4x:           /p880/,
    lg_optimus_black:        /p970/,
    lg_optimus_g:            /lg-e987|lg-e970|lg-ls970|lg-f180/,
    lg_optimus_lte:          /lg-lu6200/,
    lg_optimus_one:          /p500/,
    nokia_lumia_635:         /lumia 635/,
    nokia_lumia_730:         /lumia 730/,
    nokia_lumia_735:         /lumia 735/,
    nokia_lumia_720:         /lumia 720/,
    nokia_lumia_810:         /lumia 810/,
    nokia_lumia_820:         /lumia 820/,
    nokia_lumia_822:         /lumia 822/,
    nokia_lumia_830:         /lumia 830/,
    nokia_lumia_900:         /lumia 900/,
    nokia_lumia_920:         /lumia 920/,
    nokia_lumia_930:         /lumia 930/,
    nokia_lumia_925:         /lumia 925/,
    nokia_lumia_928:         /lumia 928/,
    nokia_lumia_1020:        /lumia 1020/,
    nokia_n8:                /nokian8/,
    nokia_n900:              /maemo/,
    nokia_n97:               /nokian97/,
    nokia_x7:                /nokiax7/,
    nokia_c5:                /nokiac5/,
    nokia_c6:                /nokiac6/,
    nokia_c7:                /nokiac7/,
    blackberry:              /bb10|blackberry/,
    xperia_iron:             /ls28i/,
    xperia_s:                /lt26i/,
    xperia_sola:             /mt27i/,
    xperia_u:                /st25i/,
    xperia_z:                /c660[2-3]|c6806/,
    xperia_z1:               /so-01f/,
    motorola_atrix2:         /mb865/,
    motorola_atrix4g:        /mb860/,
    motorola_defy:           /mb525/,
    motorola_droid:          /esd20/,
    motorola_droid3:         /droid3/,
    motorola_droid4:         /droid4/,
    motorola_droid_razar:    /razr|xt907/,
    motorola_droid_razar_hd: /razr hd/,
    motorola_droidx:         /droidx/,
    motorola_milestone:      /motoa953/,
    motorola_nexus6:         /nexus 6/,
    motorola_g:              /xt103[2-4]/,
    motorola_x:              /xt1049|xt1052|xt1058/,
    Lenovo_A850:             /lenovo[- ]a850|a850/,
    Lenovo_A889:             /lenovo[- ]a889|a889/,
    nexus_5x:                /nexus 5x/,
    nexus_6p:                /nexus 6p/
};

export const tablets = {
    galaxy_tab_8_9:          /gt-p7320/,
    galaxy_tab_2_7:          /gt-p3100/,
    galaxy_tab_1_10:         /gt-p7100|gt-p7500|gt-p7510/,
    galaxy_tab_2_10:         /gt-p5100|gt-p5110/,
    galaxy_tab_3_10:         /gt-p52[0-9]0/,
    galaxy_tab_4_10:         /sm-t53[0-9]|sm-t530nu/,
    samsung_nexus_10:        /gt-p8110|sm-t535/,
    galaxy_note_8:           /gt-n5110/,
    galaxy_note_10:          /gt-n8000|gt-n8005|gt-n8010|gt-n8013|gt-n8020/,
    asus_transformer:        /transformer/,
    asus_nexus7:             /nexus 7/,
    blackberry_pb:           /playbook/,
    kindle_fire:             /kftt/,
    kindle_fire_hd7:         /kfthwi/,
    'kindle_firehd8.9':        /kfjwi/,
    motorola_xoom:           /xoom/,
    motorola_xyboard:        /mz617/,
    'Lenovo_TAB_2_A7-30':      /lenovo tab 2 a7-30/
};

export default {
    /*
     * NB! apple devices detects via screen resolution in points
     * Dictionary of { device_alias: screen_height }
     */

    apple: {
        iphone: {
            iphone_4: 480,
            iphone_5: 568,
            iphone_6: 667,
            iphone_6_plus: 736,
            iphone_x: 812
        },
        ipod: {
            ipod: 480
        },
        ipad: {
            ipad: 1024,
            ipad_pro: 1366
        }
    },

    /*
     *  Dictionary of { device_alias: device_name } pairs
     *  where device_alias - uniq Playtech device identificator
     *  and device_name - part of device user agent
     */

    ua: {
        ...phones,
        ...tablets
    }
};

